






import { defineComponent } from '@vue/composition-api';
import { isYodaEnv } from '@/utils/env';
import { yoda } from '@/utils/yoda';

export default defineComponent({
    name: 'top-bar',
    setup() {

        const goBack = () => {
            if (!isYodaEnv) {
                window.history.go(-1);
            } else {
                yoda.component.backOrCloseWeb();
            }
        };

        return {
            goBack,
        };
    },
});
